import { JudgeDetailPageStatePresenter } from '@/presentation/presenters/judgeDetail/judgeDetailPageStatePresenter'
import { JudgeDetailPageStateViewModel } from '@/presentation/viewmodels/judgeDetail/judgeDetailPageStateViewModel'

export function useJudgeDetailPageStatePresenter(
  presenter: JudgeDetailPageStatePresenter = new JudgeDetailPageStatePresenter(new JudgeDetailPageStateViewModel())
) {
  return {
    isHideJudgeCaseList: presenter.isHideJudgeCaseList,
    setFlagIsHideJudgeCaseList: presenter.setFlagIsHideJudgeCaseList.bind(presenter),
    reverseFlagIsHideJudgeCaseList: presenter.reverseFlagIsHideJudgeCaseList.bind(presenter),
    downloadTestCase: presenter.downloadTestCase.bind(presenter)
  }
}
